<template>
  <DentalLoader />
  <DentalHeader />
  <router-view v-slot="{ Component }">
    <transition :name="'fade'">
      <component :is="Component" />
    </transition>
  </router-view>
  <DentalTop />
  <DentalFooter />
</template>

<script>
import DentalHeader from "@/components/DenteloHeader.vue";
import DentalFooter from "./components/DenteloFooter.vue";
import DentalTop from "./components/DenteloTop.vue";
import DentalLoader from "@/components/DenteloLoader.vue";
document.addEventListener("contextmenu", (event) => event.preventDefault());
export default {
  name: "App",
  components: {
    DentalHeader,
    DentalFooter,
    DentalTop,
    DentalLoader,
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
